import React from "react";
import { ManageEmployeeContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";
import ManageEmployeeDistributionContainer from "../../../containers/Distribution/ManageEmployeeDistribution/ManageEmployeeDistribution";
import WithdrawalSummaryContainer from "../../../containers/Distribution/WithdrawalSummaryContainer/WithdrawalSummaryContainer";
import { ManageDistributionProvider } from "../../../contexts";
const WithdrawalSummary = (props) => {
  return (
    // <ManageDistributionProvider>
    <WithdrawalSummaryContainer {...props} />
    // </ManageDistributionProvider>
  );
};

export default WithdrawalSummary;
